<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer mode="side" class="sidenav" [fixedInViewport]=true
               [attr.role]="graphicUtils.isScreenWidthGreater(gmService.SMALL_SCREEN_THRESHOLD) ? 'dialog' : 'navigation'"
               [mode]="graphicUtils.isScreenWidthGreater(gmService.SMALL_SCREEN_THRESHOLD) ? 'over' : 'side'"
               [opened]="graphicUtils.isScreenWidthGreater(gmService.SMALL_SCREEN_THRESHOLD) === false">
    <div class="sidenavContent sidenavLogoContainer">
      <img alt="logoSidenav" class="logoSidenav" src="assets/logo.png"/>
    </div>
    <div *ngFor="let item of gmService.user.menuItems"
         (click)="clickAndClose(item, drawer)"
         [class]="item.id === selectedItem ? 'sidenav-item item-selected' : 'sidenav-item'">
      <p class="sidenavContent">
        {{'MENU.'+item.id | translate}}
      </p>
    </div>

  </mat-sidenav>
  <mat-sidenav-content class="sidenavMainContent">
    <div class="fullPageMainContent">
      <app-topbar [componentName]="selectedItem" [drawer]="drawer"></app-topbar>
      <div class="pageBodyContainer">
          <router-outlet></router-outlet>
      </div>
    </div>

  </mat-sidenav-content>
</mat-sidenav-container>
